const InputBoilerplate = {
    props: {
        name: {
            type: String,
            required: true,
        },

        namespace: {
            type: String,
            required: true,
        },

        inputData: {}
    },

    watch: {
        inputData() {
            if (this.inputData) {
                this.loadFieldData();
            }
        }
    },

    mounted() {
        if (this.inputData) {
            this.loadFieldData();
        }
    },
};

export default InputBoilerplate;
